module.exports = __webpack_public_path__ + "img/main.b075147b.png";